export type RouteComplianceView = {
  openRemediations: number;
  criticalViolations: number;
  pendingCorrectiveActions: number;
};

export function pickComplianceSummary(
  compliance: RouteComplianceView | null | undefined
): RouteComplianceView | null {
  if (!compliance) return null;
  if (
    compliance.openRemediations === 0 &&
    compliance.criticalViolations === 0 &&
    compliance.pendingCorrectiveActions === 0
  ) {
    return null;
  }
  return compliance;
}
